import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";
import { Box, Container, Typography , Button } from "@mui/material";
import CountdownTimer from "components/helper/CountdownTimer";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Link } from "react-router-dom";

import HeroLogo from '../../assets/Hero_logo.png';
import HeroSecond from '../../assets/hero_second.png';
import HeroBtn from '../../assets/HeroButton.png';
import HeroIconOne from '../../assets/IconHeroOne.svg';
import HeroIconTwo from '../../assets/IconHeroTwo.svg';
import HeroIconThree from '../../assets/IconHeroThree.svg';
import HeroBgSecTwoSmall from '../../assets/HeroSecondSmall.png';
import HeroMiddle from '../../assets/HeroMiddle.png';
import HeroBgLast from '../../assets/BgIlageHeroTwoLast.png';
import HeroImgLast from '../../assets/BgIlageHeroLast.png';
import HeroLastImg from '../../assets/HeroVeryLast.png';


const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const targetDate = new Date("2024-11-01T23:59:59").getTime();

  return (
    <div style={{ width: "100%", padding: "0em" }}>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        alignItems="center"
        gap="1em"
        justifyContent="center"
        padding="2em 1em"
        textAlign="flex-start"
        color="#FFFFFF"
        backgroundColor="#0D1B2A"
        position="relative"
      >
        <Box
          flex={1}
          display="flex"
          padding={isMobile ? 0 : "0em 2em 0em 5em"}
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="flex-start"
          position="relative"
        >
          <Box marginBottom="1em">
            <h4 style={{ fontSize: "1.2em", margin: "0", color: "#7AF8EA", fontWeight: 300 }}>2024</h4>
            <h1
              style={{
                fontSize: isMobile ? "2em" : "3em",
                margin: "0.5em 0",
                fontWeight: "bold",
              }}
            >
              COLLOQUE DE <br /> L'INDÉPENDANCE À LA SOUVERAINETÉ NUMÉRIQUE
            </h1>
          </Box>
          <Box marginBottom="2em">
            <p style={{ margin: "0", fontSize: "1em", color: "#A9BACB" }}>
              <span role="img" aria-label="Location">
                📍
              </span>{" "}
              Nusa Dua, Bali - Indonesia
              <span style={{ margin: "0 0.5em" }}>|</span>
              <span role="img" aria-label="Calendar">
                📅
              </span>{" "}
              November 14 - 16, 2022
            </p>
          </Box>
          <Link to="/auth" style={{ textDecoration: "none" }}>
          <button
            style={{
              display: "flex",
              width: isMobile ? "100%" : "426px",
              maxWidth: "426px",
              height: isMobile ? "60px" : "115px",
              padding: "0px 20px",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
              color: "#000",
              textAlign: "center",
              fontSize: isMobile ? "18px" : "32px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "14px",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              cursor: "pointer",
              border: "none",
              backgroundColor: "#7AF8EA",
            }}
          >
            REGISTER NOW
          </button>
          </Link>
        </Box>
        <Box
          flex={1}
          display={isMobile ? "none" : "block"}
          sx={{
            backgroundImage: `url(${HeroLogo})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
            width: "100%",
            minHeight: "700px",
            position: "relative",
          }}
        ></Box>
        <Box sx={{
          display : isMobile ? "block" : "none",
          width :"100%",
          height :"2em",
        }} >

        </Box>
        {/* Countdown Container */}
        <Box
          sx={{
            display: "flex",
            position: "absolute",
            bottom: isMobile ? "-6em" : "-4.4em",
            width: isMobile ? "100%" : "693.7px", // Full width on mobile
            height: "8.75em",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            backgroundColor: "#001B30",
            borderRadius: isMobile ? "0px" : "10px",
            boxShadow: "0px 5px 25px 0px rgba(4, 3, 3, 0.15)",
            padding: "1em",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${HeroLogo})`,
              backgroundSize: "100% 419.715%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "0px -286.601px",
              opacity: 0.2, // Reduce opacity to make the background less visible
              zIndex: 1,
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 2, // Ensure the countdown is above the background
              color: "#FFFFFF",
              fontSize: isMobile ? ".8em" : "1.5em", // Adjust font size for mobile
              textAlign: "center",
              width: "100%", // Ensure countdown takes full width on mobile
            }}
          >
            <CountdownTimer targetDate={targetDate} isMobile={isMobile} />
          </Box>
        </Box>
      </Box>

            {/* SECTION 2 */}

      <Box
  display="flex"
  flexDirection={isMobile ? "column" : "row"}
  alignItems="center"
  gap="1em"
  justifyContent="space-around"
  padding={isMobile ? "0" : "2em 8em"}
  color="#FFFFFF"
  backgroundColor="#ffffff"
  position="relative"
  marginTop="8em"
>
<Box flex={isMobile ? "0 0 auto" : "1"} textAlign="center" position='relative'>
    <img width={isMobile ? 400 : "auto"} src={HeroSecond} alt="about_event" />
    <Button 
    sx={{
      display : 'flex',
      flexDirection :"row",
      flexWrap :'nowrap',
      gap :"1em",
      position : "absolute",
      color:"#090809",
      fontWeight :"500",
      fontSize :"1em",
      bottom :"40px",
      left: "0px"
    }}
    >
      <img width={isMobile ? 24 : "auto"}  src={HeroBtn} alt="Play" />
      WATCH TOUR
    </Button>
</Box>

  <Container
    maxWidth="xl"
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: 'left',
      gap : isMobile ? "1em" : "1.5em",
      padding: '2em 5em 0em 5em',
      flex: isMobile ? "0 0 auto" : "1"
    }}
  >
    <Typography
      variant="span"
      component="span"
      gutterBottom
      sx={{
        color: "black",
        fontSize: isMobile ? "1rem" : ".8rem",
        fontWeight: "normal",
        marginBottom: "0px",
        marginTop: '1em',
        textTransform: "uppercase"
      }}
    >
      À propos de l'événement
    </Typography>
    <Typography
      variant="p"
      component="span"
      gutterBottom
      sx={{
        fontWeight: "bold",
        color: "black",
        fontSize: isMobile ? "1rem" : "1.5rem",
        marginBottom: "0px",
        marginTop: '1em'
      }}
    >
      Plus Grand Colloque sur le <br /> Numérique et la Technologie
    </Typography>
    <Typography
      variant="p"
      component="p"
      gutterBottom
      sx={{
        color: "black",
        fontSize: isMobile ? "1rem" : "1rem",
        marginBottom: "0px",
        marginTop: '1em',
        maxWidth: "40em"
      }}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris
    </Typography>

    <Container
    maxWidth="xl"
    sx={{
      display: "flex",
      flexDirection: isMobile ? "column"  : "row",
      gap :"1em",
      justifyContent: "left",
      textAlign: 'left',
      padding: '2em 5em 0em 0em',
      flex: isMobile ? "0 0 auto" : "1"
    }}
  >
    <Box>
    <Typography
      variant="p"
      component="h2"
      gutterBottom
      sx={{
        color: "black",
        fontSize: isMobile ? "1rem" : "1rem",
        marginBottom: "0px",
        marginTop: '1em',
        maxWidth: "40em"
      }}
    >
      Avantages de l’événement
    </Typography>
    <Typography
      variant="span"
      component="span"
      gutterBottom
      sx={{
        color: "black",
        fontSize: isMobile ? "1rem" : ".8rem",
        fontWeight: "normal",
        marginBottom: "0px",
        marginTop: '1em',
      }}
    >
      Lorem ipsum dolor sit amet, <br/>
      consectetur adipiscing elit
    </Typography>

      <ul style={{
        display :"flex",
        flexDirection :'column',
        gap: "1em",
        padding :'0px',
        margin :'1em 0em 0em 0em',
        listStyle :'none'
      }} >
      <li style={{
        display: "flex",
        flexDirection: "row",
        gap: "1em",
        flexWrap: "nowrap",
        alignItems: "center", // Centers vertically
      }}>
        <img width={30} src={HeroIconOne} alt="icon" />
        <Typography
          variant="p"
          component="p"
          gutterBottom
          sx={{
            color :'#090809',
            fontSize: isMobile ? "1rem" : "1rem",
            marginBottom: "0px",
            maxWidth: "20em",
            fontsize: "16px",
            fontstyle: "normal",
            fontWeight: 600,
            lineHeight: "20.8px", /* 130% */
            textTransform: "capitalize",
          }}
        >
          développer le réseau
        </Typography>
      </li>

      <li style={{
        display: "flex",
        flexDirection: "row",
        gap: "1em",
        flexWrap: "nowrap",
        alignItems: "center", // Centers vertically
      }}>
        <img width={30} src={HeroIconTwo} alt="icon" />
        <Typography
          variant="p"
          component="p"
          gutterBottom
          sx={{
            color :'#090809',
            fontSize: isMobile ? "1rem" : "1rem",
            marginBottom: "0px",
            maxWidth: "20em",
            fontsize: "16px",
            fontstyle: "normal",
            fontWeight: 600,
            lineHeight: "20.8px", /* 130% */
            textTransform: "capitalize",
          }}
        >
          Speakers incroyables
        </Typography>
      </li>

      <li style={{
        display: "flex",
        flexDirection: "row",
        gap: "1em",
        flexWrap: "nowrap",
        alignItems: "center", // Centers vertically
      }}>
        <img width={30} src={HeroIconThree} alt="icon" />
        <Typography
          variant="p"
          component="p"
          gutterBottom
          sx={{
            color :'#090809',
            fontSize: isMobile ? "1rem" : "1rem",
            marginBottom: "0px",
            maxWidth: "20em",
            fontsize: "16px",
            fontstyle: "normal",
            fontWeight: 600,
            lineHeight: "20.8px", /* 130% */
            textTransform: "capitalize",
          }}
        >
          Carrière professionnelle
        </Typography>
      </li>
      </ul>
      <Link to="/auth" style={{ textDecoration: "none" }}>
      <button
            style={{
              display: "flex",
              width: isMobile ? "100%" : "164.3px",
              maxWidth: "426px",
              height: isMobile ? "60px" : "49px",
              padding: "16px 31.674px 17.5px 32px",
              margin :'2em 0em 0em 0em',
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
              color: "#000",
              textAlign: "center",
              fontSize: isMobile ? "1em" : ".7em",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "14px",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              cursor: "pointer",
              border: "none",
              backgroundColor: "#7AF8EA",
            }}
          >
            REGISTER NOW
          </button>
          </Link>

    </Box>
    <img width={250} src={HeroBgSecTwoSmall} alt="background" />
    </Container>

  </Container>
  
  
    </Box>

    <Box
  display="flex"
  flexDirection={isMobile ? "column" : "row"}
  alignItems="center"
  gap="1em"
  justifyContent="space-around"
  padding={isMobile ? "0" : "0"}
  color="#FFFFFF"
  backgroundColor="#ffffff"
  sx={{
    backgroundImage: `url(${HeroMiddle})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    overflow: "hidden",
    minWidth: "100%",
    minHeight: 450,
    marginTop: "8em",
  }}
>
  {/* Overlay filter */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#001B30",
      opacity: 0.6,
      zIndex: 1,
    }}
  />


  <Box
    sx={{
      position: "relative",
      zIndex: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center", // Center horizontally
      justifyContent: "center", // Center vertically
      textAlign: "center", // Center text alignment
      gap: "1.5em", // Add spacing between elements
      width: "100%", // Ensure it takes full width to properly center content
      height: "100%", // Ensure it takes full height to vertically center
    }}
  >
    <Typography
      variant="p"
      component="h2"
      gutterBottom
      sx={{
        color: "#ffffff",
        fontSize: isMobile ? "1rem" : "1.5rem",
        marginBottom: "0px",
        maxWidth: "20em",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "20.8px",
        textTransform: "capitalize",
      }}
    >
      Inscrivez-Vous maintenant
    </Typography>
    <Typography
      variant="p"
      component="p"
      gutterBottom
      sx={{
        color: "#ffffff",
        fontSize: isMobile ? "1rem" : "1rem",
        marginBottom: "0px",
        marginTop: "1em",
        maxWidth: "30em",
      }}
    >
      Reservez votre place dès maintenant. inscrivez-vous et ne ratez pas la
      chance pour atteindre notre événement.
    </Typography>
    <Link to="/auth" style={{ textDecoration: "none" }}>
    <button
      style={{
        display: "flex",
        width: isMobile ? "100%" : "426px",
        maxWidth: "426px",
        height: isMobile ? "60px" : "115px",
        padding: "0px 20px",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        color: "#000",
        textAlign: "center",
        fontSize: isMobile ? "18px" : "32px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "14px",
        letterSpacing: "1.5px",
        textTransform: "uppercase",
        cursor: "pointer",
        border: "none",
        backgroundColor: "#7AF8EA",
      }}
    >
      REGISTER NOW
    </button>
    </Link>
  </Box>
</Box>


<Box
    sx={{
      display: "flex",
      marginTop : "5em",
      flexDirection: "column",
      alignItems: "center", 
      justifyContent: "center", 
      textAlign: "center", 
      gap: ".5em", 
      width: "100%",
      height: "100%", 
    }}
  >
    <Typography
      variant="p"
      component="h4"
      gutterBottom
      sx={{
        color: "#001B30",
        fontSize: isMobile ? "1rem" : "1rem",
        marginBottom: "0px",
        maxWidth: "20em",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20.8px",
        textTransform: "uppercase",
      }}
    >
      Partenaires et sponsors
    </Typography>
    <Typography
      variant="p"
      component="p"
      gutterBottom
      sx={{
        color: "#090809",
        fontSize: isMobile ? "1.5rem" : "2rem",
        marginBottom: "0px",
        fontWeight :'bold',
        marginTop: "1em",
        maxWidth: "40em",
      }}
    >
      Nos partenaires et sponsors officiels
    </Typography>
    <Typography
      variant="p"
      component="p"
      gutterBottom
      sx={{
        color: "#757575",
        fontSize: isMobile ? "1rem" : "1rem",
        marginBottom: "0px",
        marginTop: "1em",
        maxWidth: "40em",
      }}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua
    </Typography>
    </Box>

    <Container
  maxWidth="xl"
  disableGutters
  sx={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: "0em",
    justifyContent: "center",
    textAlign: "center",
    padding: "2em 0em 0em 0em",
    flex: isMobile ? "0 0 auto" : "1",
    alignItems: "stretch", // Ensures all children have the same height
  }}
>
<Box
  sx={{
    backgroundImage: `url(${HeroBgLast})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    flex: "1 1 0",
    minHeight: isMobile ? "200px" : "450px",
    display: "flex",
    alignItems: "center", // Centers content vertically
    justifyContent: "center", // Centers content horizontally
  }}
>
  {/* Inner Box with event details */}
  <Box
    sx={{
      backgroundColor: "rgba(0, 0, 0, 0.8)", // Semi-transparent background
      color: "#FFFFFF",
      padding: "1.5em",
      textAlign: "center",
      display :"flex",
      justifyContent : "center",
      alignItems: "center",
      flexDirection :"column",
      flexWrap :"nowrap",
      maxWidth: "300px",
    }}
  >
    <Typography
      variant="h5"
      component="h2"
      sx={{
        fontWeight: "bold",
        marginBottom: "0.5em",
        fontSize: "1.5em",
      }}
    >
      Lieu De L'événement
    </Typography>
    <Typography
      variant="body2"
      sx={{
        marginBottom: "1em",
        fontSize :".8em",
        color :"#D5D5D5"
      }}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
    </Typography>

    {/* Location */}
    <Box
      display="flex"
      alignItems="center"
      gap="0.5em"
      sx={{
        marginBottom: "0.5em",
        fontSize :".8em",
        color :"#D5D5D5",
         borderBottom :"1px solid #D5D5D5",
         paddingBottom: "0.5em",
      }}
    >
      <LocationOnIcon />
      <Typography variant="body2">Nusa Dua, Bali - Indonesia</Typography>
    </Box>

    {/* Date */}
    <Box
      display="flex"
      alignItems="center"
      gap="0.5em"
      sx={{
        marginBottom: "0.5em",
        fontSize :".8em",
        color :"#D5D5D5",
         borderBottom :"1px solid #D5D5D5",
         paddingBottom: "0.5em",
      }}
    >
      <EventIcon />
      <Typography variant="body2">November 14 - 16, 2022</Typography>
    </Box>

    {/* Time */}
    <Box
      display="flex"
      alignItems="center"
      gap="0.5em"
      fontSize=".8em"
      color ="#D5D5D5"
      sx={{
        borderBottom :"1px solid #D5D5D5",
        paddingBottom: "0.5em",
     }}
    >
      <AccessTimeIcon />
      <Typography  variant="body2">08.00 A.M. - 16.00 P.M.</Typography>
    </Box>
  </Box>
</Box>


  <img
    src={HeroImgLast}
    alt="event"
    style={{
      flex: "1 1 0", // Ensures equal width and grows equally
      objectFit: "cover",
      height: "100%",
      minHeight: isMobile ? "200px" : "450px",
      width: isMobile ? "100%" : "200px", // Ensure it fills the space equally
    }}
  />

  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2259.711914068158!2d3.052559418527109!3d36.777398304122116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128fb250ed2c2957%3A0xf54d6adcd3a4bafb!2sH%C3%B4tel%20El%20Aurassi!5e0!3m2!1sfr!2sdz!4v1729161134888!5m2!1sfr!2sdz"
    style={{
      flex: "1 1 0", // Ensures equal width and grows equally
      height: "100%",
      minHeight: isMobile ? "200px" : "450px",
      width: "100%", // Ensure it fills the space equally
      border: "0",
    }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</Container>

<Box
  display="flex"
  flexDirection={isMobile ? "column" : "row"}
  alignItems="center"
  gap="1em"
  justifyContent="space-around"
  padding={isMobile ? "0" : "0"}
  color="#FFFFFF"
  backgroundColor="#ffffff"
  sx={{
    backgroundImage: `url(${HeroLastImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    overflow: "hidden",
    minWidth: "100%",
    minHeight: 450,
    marginTop: "0em",
  }}
>
  {/* Overlay filter */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#001B30",
      opacity: 0.6,
      zIndex: 1,
    }}
  />


  <Box
    sx={{
      position: "relative",
      zIndex: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center", // Center horizontally
      justifyContent: "center", // Center vertically
      textAlign: "center", // Center text alignment
      gap: "1.5em", // Add spacing between elements
      width: "100%", // Ensure it takes full width to properly center content
      height: "100%", // Ensure it takes full height to vertically center
    }}
  >

<Box
  sx={{
    backgroundColor: "rgba(0, 0, 0, 0.8)", // Semi-transparent background
    color: "#FFFFFF",
    padding: "2.5em",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    flexWrap: "nowrap",
    width: isMobile ? "100%" : "60%", 
  }}
>
    <Typography
      variant="h5"
      component="h2"
      sx={{
        fontWeight: "bold",
        marginBottom: "0.5em",
        fontSize: "1.5em",
      }}
    >
      Rejoignez-nous à la 2ème Semaine de Travail <br/> Evénementielle du 14 au 16 novembre 2022 - Alger
    </Typography>
    <Typography
      variant="p"
      component="p"
      gutterBottom
      sx={{
        color: "#ffffff",
        fontSize: isMobile ? "1rem" : "1rem",
        marginBottom: "0px",
        marginTop: "1em",
        maxWidth: "30em",
      }}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
      veniam, quis nostrud exercitation ullamco laboris
    </Typography>
    <Link to="/auth" style={{ textDecoration: "none" }}>
    <button
      style={{
        display: "flex",
        marginTop :'2em',
        width: isMobile ? "100%" : "200px",
        maxWidth: "200px",
        maxHeight :'54px',
        height: isMobile ? "60px" : "54px",
        padding: "0px 5px",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        color: "#000",
        textAlign: "center",
        fontSize: isMobile ? "18px" : "16px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "14px",
        letterSpacing: "1.5px",
        textTransform: "uppercase",
        cursor: "pointer",
        border: "none",
        backgroundColor: "#7AF8EA",
      }}
    >
      REGISTER NOW
    </button>
    </Link>
    </Box>
  </Box>
</Box>



      <Footer marginTop={'0em'} />
    </div>
  );
};

export default Hero;
